import * as m from "mithril";
import '../../components/ModalDialog.css';
import CustomSvgIcon, { CustomSvgIconType } from "../../components/CustomSvgIcon";
import { PriceLevel, SeatPriceGuideItemDTO, TripDTO } from "../../apiclient/ApiDtos";
import { MessageProvider } from "../../context/AppMessages";
import { buildSeatFeatureClass } from "../seatselection/BusLayoutPage";

export default function MixedSeatTypesWarningDialog(): m.Component<{
    shouldOpen: boolean,
    title?: string,
    message?: string,
    messageProvider: MessageProvider,
    iconType?: CustomSvgIconType,
    iconThemeClass?: string,
    priceGuide: SeatPriceGuideItemDTO[],
    onClosed: () => void,
    tripDetails: TripDTO,
    actionItems?: { label: string, onclick: () => void }[]
}> {
    let dialogElem: HTMLDialogElement | null = null;

    let isShowingSeatPricesChart: boolean = false;
    return {
        oncreate(vnode) {
            dialogElem = vnode.dom as HTMLDialogElement;
        },

        onbeforeupdate(vnode) {
            if (dialogElem) {
                if (dialogElem.open) {
                    if (vnode.attrs.shouldOpen == false) {
                        dialogElem.close();
                    }
                } else {
                    if (vnode.attrs.shouldOpen) {
                        dialogElem.showModal();
                    }
                }
            }
        },


        view(vnode) {

            return m("dialog", {
                class: "dialog-modal"
            },
                [
                    vnode.attrs.title && m("div.card-header", { class: "pb-2 px-1 bg-white border-0" }, [
                        (vnode.attrs.iconType != undefined) ?
                            m("span.mr-1",
                                m(CustomSvgIcon, {
                                    iconType: vnode.attrs.iconType,
                                    themeCssClass: vnode.attrs.iconThemeClass ? vnode.attrs.iconThemeClass : "svg-small svg-warning"
                                }),
                            ) : null,

                        (vnode.attrs.title != null) ?
                            m("span", { class: "font-weight-bold mb-3" }, vnode.attrs.title) : null,

                    ]),
                    m("div.card-body.pt-1.px-1", [
                        (vnode.attrs.message != null) ?
                            m("div", { class: "mb-1 small" }, vnode.attrs.message) : null,

                        vnode.children,

                        //priceGradeMap.size < 4 && 
                        m("div.mt-3 p-2 rounded", {
                            style: "background-color: rgb(247, 247, 247) !important;"
                        },
                            m("div.d-flex justify-content-between ", {
                                onclick: (event) => {
                                    isShowingSeatPricesChart = !isShowingSeatPricesChart;
                                }
                            },
                                m("div.small text-info", vnode.attrs.messageProvider.get("common.seat_prices_chart")),
                                m("div",
                                    m(CustomSvgIcon, {
                                        iconType: isShowingSeatPricesChart ? 'keyboard_arrow_up' : 'keyboard_arrow_down',
                                        themeCssClass: "svg-info svg-medium"
                                    })
                                )
                            ),
                            isShowingSeatPricesChart &&
                            m("div.mt-2",
                                [...vnode.attrs.priceGuide]
                                    .map(seatPriceItem =>
                                        m("div.d-flex.justify-content-between.align-items-center my-1", [
                                            m("div.seat", [
                                                m("span.seat seat-pricing en-only mr-2 ", {
                                                    class: buildSeatFeatureClass(seatPriceItem.classification)
                                                }, "")
                                            ]),
                                            m("div.text-success", [
                                                `${seatPriceItem.price.currency} `,
                                                seatPriceItem.price.amount.toLocaleString("en-US")
                                            ])
                                        ])
                                    )
                            )
                        )


                    ]),
                    [
                        (vnode.attrs.actionItems != null) ?
                            m("div.card-footer.px-1", { class: "text-right border-0 bg-white pt-0" },
                                vnode.attrs.actionItems.map(item => {
                                    return m("button", {
                                        class: 'btn btn-outline-primary btn-sm mr-1',
                                        onclick: function (event) {
                                            isShowingSeatPricesChart = false
                                            item.onclick();
                                        }
                                    }, item.label)
                                })
                            ) : null
                    ],


                ]
            )
        }
    };
}

